import * as dashboardOperations from './operations';

export {
    dashboardOperations
};